import Drawer from './src/index.vue'

export default Drawer
